// export const classes = [{ Dubai: "compact-wrapper" }];
// export const classes = [{ Byte_Nfc: "compact-wrapper" }];
// export const classes = [{ Stock: "compact-wrapper" }];
export const classes = [{ Hisab_Kitab: "compact-wrapper" }];
